<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.billingpaymentmethod') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BillingPaymentMethodForm
        :state="paymentMethod"
        :isSubmitted="isSubmitted"
        :form.sync="form"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import { BILLING_PAYMENT_METHOD } from '../../../../helpers/enum'

export default {
  mixins: [discardFormMixin],

  data () {
    return {
      loading: false,
      isSubmitted: false,
      form: null,
    }
  },

  computed: {
    ...mapState('billing', {
      paymentMethod: 'paymentMethod',
    }),
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.billing.title'),
      current: {
        app_name: 'billing',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 3,
    })
  },

  mounted () {
    this.fetchData()
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('billing', {
      getMasterData: 'getMasterData',
      updatePaymentMethod: 'updatePaymentMethod',
    }),
    async handleSubmit (form) {
      const dataSet = (() => {
        if (form.paymentMethod === BILLING_PAYMENT_METHOD.CARD) {
          return {
            'card': {
              'card_number': form.creditCard == 'null' ? null : form.creditCard,
              'cvv_number': form.creditCardCVV,
              'expired_date_month': isNaN(form.creditCardExpireDateMonth) ? null : form.creditCardExpireDateMonth,
              'expired_date_year': isNaN(form.creditCardExpireDateYear) ? null : form.creditCardExpireDateYear,
              'holder_name': form.fullName,
            },
            'city': form.city,
            'address1': form.address1,
            'address2': form.address2,
            'zipcode': form.zipcode,
            'country_code': form.countryCode,
            'phone_number': form.phoneNumber,
          }
        }
        return null
      })()
      this.disabled = true
      this.isSubmitted = true
      const response = await this.updatePaymentMethod({
        type: form.paymentMethod,
        data: dataSet,
      })
      if (response.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    async fetchData () {
      this.loading = true
      await this.getMasterData()
      this.loading = false
      this.showFinish(this.$Progress)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/billing/method/Index.vue